<template>
    <Notification v-if="store.noDisciplinesDetected" class="is-warning is-light" :class="notificationClass" :centered="false">
        <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
        {{ translate("discipline_packages.no_disciplines_detected") }}
        <a :href="urls.eventAdmin().categoriesManagementPage(eventId)" class="ml-2">
            <span>{{ translate("discipline_packages.uncovered_categories_fix_link") }}</span>
            <span class="icon is-small"><i class="fas fa-arrow-right"></i></span>
        </a>
    </Notification>
    <Notification
        v-if="store.uncoveredCategories > 0 && !store.noDisciplinesDetected"
        class="is-warning is-light"
        :class="notificationClass"
        :centered="false"
    >
        <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
        {{ translate("discipline_packages.uncovered_categories_warning", false, [store.uncoveredCategories]) }}
        <a :href="urls.eventAdmin().categoriesManagementPage(eventId)" class="ml-2">
            <span>{{ translate("discipline_packages.uncovered_categories_fix_link") }}</span>
            <span class="icon is-small"><i class="fas fa-arrow-right"></i></span>
        </a>
    </Notification>
    <Notification
        v-if="store.disciplinesNotConfigured && store.uncoveredCategories === 0"
        class="is-warning is-light"
        :class="notificationClass"
        :centered="false"
    >
        <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
        {{ translate("admin_bracket_listing.disciplines_not_configured_warning") }}
        <a :href="urls.eventAdmin().disciplinePackagesPage(eventId)" class="ml-2">
            <span>{{ translate("discipline_packages.configure_disciplines") }}</span>
            <span class="icon is-small"><i class="fas fa-arrow-right"></i></span>
        </a>
    </Notification>
</template>

<script setup lang="ts">
    import Notification from "../../Common/Notification.vue";
    import { translate } from "../../Common/translations";
    import urls from "../../Urls/urls";
    import { useBracketsListingStore } from "./bracketsListingApp";

    defineProps<{
        eventId: number;
        notificationClass?: string;
    }>();

    const store = useBracketsListingStore();
</script>
